import cls from "@fvilers/cls";
import { ComponentProps } from "react";
import styles from "./Dialog.module.css";

type DialogHeaderProps = ComponentProps<"header">;

export function DialogHeader({ className, ...props }: DialogHeaderProps) {
  return <header className={cls(styles.DialogHeader, className)} {...props} />;
}
